// extracted by mini-css-extract-plugin
module.exports = {"reviewCard":"cj2Gr","heading":"_2Vm7D","subHeading":"_1-GwY"};